export default __webpack_public_path__ + "static/media/calendar.51970455.svg";